export default __webpack_public_path__ + "static/cdr-logo-c3edacdd1c4f1f6d66e874d7c1e94461.png";